import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import type { ReactNode } from 'react';
import { memo } from 'react';
import type { LabelAndContentColumnProps } from './labelAndContentColumn.model';
import styles from './labelAndContentColumn.module.scss';

function LabelAndContentColumnCpt({ label, content }: LabelAndContentColumnProps): ReactNode {
  return (
    <div className={styles.textContainer}>
      <CoreTypography customClassName={styles.label} variant={CoreTypographyVariant.Body02Regular}>
        {label}
      </CoreTypography>
      <CoreTypography variant={CoreTypographyVariant.Body02Regular}>{content}</CoreTypography>
    </div>
  );
}

export const LabelAndContentColumn = memo(LabelAndContentColumnCpt);
